import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";

import AB_2659 from "./AB_2659";
import AB_3274 from "./AB_3274";
import AB_3632 from "./AB_3632";
import Default from "./Default";

const abTests = {
    dev_3274__v2: loadUsualComponent(AB_3274),
    dev_3632__v2: loadUsualComponent(AB_3632),
    dev_2659__v2: loadUsualComponent(AB_2659),
};

const List = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default List;
